import React, {useState} from "react";
import {Formik} from "formik";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {FormattedMessage, injectIntl} from "react-intl";
import * as auth from "../../../store/ducks/auth.duck";
import {resetPassword} from "../../../crud/auth.crud";
import {makeStyles, withStyles, TextField} from '@material-ui/core';
import clsx from "clsx";
import logo from '../../../assets/images/royal-flora-logo2x.png';

const ResetPassword = (props) => {
    const {intl, history} = props;
    const [loading, setLoading] = useState(false);
    const [loadingButtonStyle, setLoadingButtonStyle] = useState({
        paddingRight: "2.5rem"
    });
    const CssTextField = withStyles({
        root: {
            "& label.Mui-focused": {
                color: "#c32e95"
            },
            "& .MuiInput-underline:after": {
                borderBottomColor: "#c32e95"
            },
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: "#9f8a99"
                },
                "&:hover fieldset": {
                    borderColor: "#c32e95"
                },
                "&.Mui-focused fieldset": {
                    borderColor: "#c32e95"
                }
            }
        }
    })(TextField);

    const useStyles = makeStyles(theme => ({
        container: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        textField: {
            marginLeft: theme.spacing(0),
            marginRight: theme.spacing(0),
        },
        dense: {
            marginTop: theme.spacing(2),
        },
        menu: {
            width: 200,
        },
    }));
    const classes = useStyles();

    const enableLoading = () => {
        setLoading(true);
        setLoadingButtonStyle({paddingRight: "3.5rem"});
    };

    const disableLoading = () => {
        setLoading(false);
        setLoadingButtonStyle({paddingRight: "2.5rem"});
    };


    return (
        <div className="kt-login__body">
            <div className="kt-login__icon">
                <img src={logo} alt=""/>
            </div>
            <div className="kt-login__form">
                <div className="kt-login__title">
                    <h3>
                        <FormattedMessage id="PASSWORD.FORM.RESET"/>
                    </h3>
                </div>

                <Formik
                    initialValues={{password: "", password_confirmation: '', token: ''}}
                    validate={values => {
                        const errors = {};

                        if (!values.password) {
                            errors.password = intl.formatMessage({
                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                            });
                        } else if (values.password.length < 8) {
                            errors.password = 'password must 8 characters long'
                        }
                        if (!values.password_confirmation) {
                            errors.password_confirmation = intl.formatMessage({
                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                            });
                        } else if (values.password_confirmation.length < 8) {
                            errors.password_confirmation = 'password must 8 characters long'
                        }
                        if (values.password !== values.password_confirmation) {
                            errors.password_confirmation = 'the passwords do not match'
                        }
                        if (!values.token) {
                            errors.token = intl.formatMessage({
                                id: "AUTH.VALIDATION.REQUIRED_FIELD"
                            });
                        }

                        return errors;
                    }}
                    onSubmit={(values, {setStatus, setSubmitting}) => {
                        enableLoading();
                        resetPassword(values.password, values.password_confirmation, values.token)
                            .then(({data: {message}}) => {
                                disableLoading();
                                setStatus(message);
                                history.push('/auth/login');
                            })
                            .catch((error) => {
                                const {message} = error;
                                setSubmitting(false);
                                disableLoading();
                                setStatus(message);
                            });
                    }}
                >
                    {({
                          values,
                          status,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting
                      }) => (
                        <form onSubmit={handleSubmit} className="kt-form">
                            {status && (
                                <div role="alert" className="alert alert-danger">
                                    <div className="alert-text">{status}</div>
                                </div>
                            )}
                            <div className="form-group">
                                <CssTextField
                                    className={clsx(classes.textField, classes.dense)}
                                    margin="dense"
                                    variant="outlined"
                                    type="password"
                                    label="Password"
                                    fullWidth={true}
                                    name="password"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.email}
                                    helpertext={touched.password && errors.password}
                                    error={Boolean(touched.password && errors.password)}
                                />
                            </div>
                            <div className="form-group">
                                <CssTextField
                                    className={clsx(classes.textField, classes.dense)}
                                    margin="dense"
                                    variant="outlined"
                                    label="Confirm password"
                                    type="password"
                                    fullWidth={true}
                                    name="password_confirmation"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.password_confirmation}
                                    helpertext={touched.password_confirmation && errors.password_confirmation}
                                    error={Boolean(touched.password_confirmation && errors.password_confirmation)}
                                />
                            </div>
                            <div className="form-group">
                                <CssTextField
                                    className={clsx(classes.textField, classes.dense)}
                                    margin="dense"
                                    variant="outlined"
                                    label="Code"
                                    type="text" autoComplete="off"
                                    fullWidth={true}
                                    name="token"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values.token}
                                    helpertext={touched.token && errors.token}
                                    error={Boolean(touched.token && errors.token)}
                                />
                            </div>
                            <div className="kt-login__actions">
                                <button
                                    id="kt_login_signin_submit"
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                                        {
                                            "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                                        }
                                    )}`}
                                    style={loadingButtonStyle}
                                >
                                    Submit
                                </button>
                            </div>
                            <div className="kt-login__actions">
                                <Link
                                    to="/auth"
                                    className="kt-link kt-login__link-forgot"
                                >
                                    <FormattedMessage id="AUTH.BUTTON.LOGIN"/>
                                </Link>
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default injectIntl(withRouter(connect(null, auth.actions)(ResetPassword)));
